/**
 * Dynamically sets the document.title and restores it on unmount.
 * Used on customer-facing pages so the browser tab shows the merchant's brand
 * (e.g. "Checkout — Pack Essentiel") instead of the platform default.
 */
import { useEffect } from 'react';

export function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return undefined;
    const previous = document.title;
    document.title = title;
    return () => { document.title = previous; };
  }, [title]);
}
